import {
  DealStageSelector,
  type DealStageSelectorProps,
} from './deal-stage-selector';

// DEV NOTE: this is just a wrapper around the DealStatusSelector component
// that is used to make the button look like a button
export function DealStageSelectorButton({
  id,
  shortId,
  value,
  hideCopy = false,
  side = 'left',
  className,
}: DealStageSelectorProps) {
  return (
    <div className="p-0 h-fit">
      <DealStageSelector
        id={id}
        shortId={shortId}
        value={value}
        hideCopy={hideCopy}
        side={side}
        className={className}
      />
    </div>
  );
}
